export const modalInitialState = {
    isModalOpen : false,
    setIsModalOpen : () => false
}